import { render, staticRenderFns } from "./TrainingChart.vue?vue&type=template&id=3e4980ac&scoped=true&"
import script from "./TrainingChart.vue?vue&type=script&lang=js&"
export * from "./TrainingChart.vue?vue&type=script&lang=js&"
import style0 from "./TrainingChart.vue?vue&type=style&index=0&id=3e4980ac&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4980ac",
  null
  
)

export default component.exports